import React, {useEffect} from 'react';
import track from 'utils/track';
import Impact from './impact.jsx';
import {SalesCta67Standalone} from 'components/SalesCta';

export default function () {
  useEffect(
    () =>
      track('Product Viewed', {
        product_id: 'tntg',
        sku: 'tntg',
        name: 'TNTG Impact Kit',
        variant: 'tntg-impactkit-special-wlc-30daytrial-st',
        value: 67,
        currency: 'usd'
      }),
    []
  );
  return <Impact noExitIntent salesFlag="sales67" salesCta={<SalesCta67Standalone trees />} />;
}
